import {
  lego,
  legoInit,
  legoZpmExposure,
  legoAreaExposure,
  legoGoodsExposure
} from '@zz-common/lego'
import pageIdConfig from '@/page.config.js'
export default {
  install(Vue) {
    Vue.prototype.$lego = lego
    Vue.prototype.$legoZPMExposure = legoZpmExposure
    Vue.prototype.$legoAreaExposure = legoAreaExposure
    Vue.prototype.$legoGoodsExposure = legoGoodsExposure
    Vue.prototype.$legoInit = (config) => {
      legoInit(Object.assign({}, pageIdConfig, config))
    }
    Object.assign(Vue.prototype.$legoInit, legoInit)
    Vue.prototype.$legoSend = (pagetype, actiontype, backup = {}) => {
      try {
        if (typeof pagetype === 'string') {
          lego.send({ pagetype, actiontype, backup })
        }
        if (typeof pagetype === 'object') {
          lego.send(pagetype)
        }
      } catch (error) {
        console.log('[error] legoSend:', error)
      }
    }
  }
}
